module.exports = __webpack_public_path__ + "static/media/fasal.66b35e8c.png";